export type ExtractHtmlAndScriptsResult = {
    html: string
    links: string[]
    scripts: string[]
};

export default function extractHtmlAndScripts(html: string): ExtractHtmlAndScriptsResult {
    const parser = new DOMParser()
    const doc = parser.parseFromString(html, "text/html")

    const styles = Array.from(doc.head.querySelectorAll("style")).map(s => s.outerHTML)
    const links = Array.from(doc.querySelectorAll("link")).map(s => s.outerHTML)
    const scripts = Array.from(doc.querySelectorAll("script")).map(s => s.outerHTML)

    doc.head.querySelectorAll("style").forEach(s => s.remove())
    doc.querySelectorAll("link").forEach(s => s.remove())
    doc.querySelectorAll("script").forEach(s => s.remove())

    const allStyles = styles.reduce((acc, style) => acc + style, "")

    const newHtml = `${allStyles} ${doc.body.innerHTML}`

    const data = {
        html: newHtml,
        links,
        scripts
    }

    return data
}